const preparation = [
  {
    year: 2023,
    title: "The Algorithmic Search Framework",
    author_span: <span>Hana Ahmed, Amani Maina-Kilaas, <b>Shifa Somji</b>, Sarah Embry, Isabel Duan, Cynthia Hom, George Montanez</span>,
    pdf: "ASF.pdf",
  },
];

const publications = [
  {
    year: 2026,
    title: "Proactive Teachability in Socially Assistive Robots through Uncertainty-Aware Clarification",
    author_span: <span><b>Shifa Somji</b>, Zachary Kingston</span>,
    location: "",
    pdf: "Teachability.pdf",
    doi: "",
  },
  {
    year: 2026,
    title: "Beyond Surveys: Predicting Student Well-being from Open-ended Video Responses using LLMs",
    author_span: <span>Thu Bui, <b>Shifa Somji</b>, Hillary Merzdorf, Nan Kong, Louis Tay, Sooyeon Jeong</span>,
    location: "ACM International Conference on Multimodal Interaction",
    pdf: "Wellbeing.pdf",
    doi: "",
  },
  {
    year: 2026,
    title: "Personalization of Speech Therapy Treatment with Socially Assistive Robots",
    author_span: <span><b>Shifa Somji</b>, Jiyeon Lee, Sooyeon Jeong </span>,
    location: "Toward Relationship-Centered Care with AI: Designing for Human Connections in Healthcare - CHI Conference on Human Factors in Computing Systems",
    pdf: "SAR_Paper.pdf",
    doi: "",
  },
  {
    year: 2024,
    title: "Language Alignment in Older Adults with Socially Assistive Robots: Implications for Aphasia Rehabilitation",
    author_span: <span><b>Shifa Somji</b>, Guven Gergerli, Jiyeon Lee, Sooyeon Jeong </span>,
    location: "62nd Annual Meeting of the Academy of Aphasia",
    pdf: "AoA_Abstract.pdf",
    doi: "",
  },
  {
    year: 2023,
    title: "xenoGI 3: using the DTLOR model to reconstruct the evolution of gene families in clades of microbes",
    author_span: <span>Nuo Liu, Tonatiuh Gonzalez, Jacob Fischer, Chan Hong, Michelle Johnson, Ross Mawhorter, Fabrizia Mugnatto, Rachael Soh, <b>Shifa Somji</b>, Joseph Wirth, Ran Libeskind-Hadas, Eliot Bush</span>,
    location: "BMC Bioinformatics",
    pdf: "xenoGI.pdf",
    doi: "https://link.springer.com/article/10.1186/s12859-023-05410-0",
  },
];

// add sections to your research here
export const pub_entries = [
  ["Publications", publications], 
  ["In Preparation", preparation],
];